module.exports = __webpack_public_path__ + "img/logo-fil-old.3cc03158.svg";